import React from 'react';
import SponsorInfoDetailsComponent from '../../../Components/UserComponents/SponsorInfoDetails';

const SponsorInfoDetailsContainer = () => {
  return <SponsorInfoDetailsComponent />;
};

export default SponsorInfoDetailsContainer;
